import React, { useEffect, useState } from 'react';
import './ChevronProcessDiagram.scss';
import { ChevronDiagramEvent } from './models/ChevronDiagramEvent';
import {
    TimelineParties,
    TimelineParty,
} from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { TimelineEventStatus } from '../../../slices/marketplace/timeline/models/enums/timeline-event-status.enum';
import {
    ActionTypeDefinition,
    MarketplaceEventActionTypeList,
} from '../../../slices/marketplace/timeline/models/timeline-action-type.model';

interface ChevronDiagramEventProps {
    chevronDiagramEvent: ChevronDiagramEvent;
    onActionClick(item: ChevronDiagramEvent): void;
    isEventActionVisible: (eventId: string) => boolean;
    party: TimelineParty;
}

export const ChevronDiagramTimelineEvent = (
    props: ChevronDiagramEventProps
) => {
    const { chevronDiagramEvent: chevronDiagramEvent } = props;
    const partyName = TimelineParties.find(
        (p) => p.id === chevronDiagramEvent.party
    )?.name;

    const [action, setAction] = useState<ActionTypeDefinition>(null);

    useEffect(() => {
        const actionType = chevronDiagramEvent.linkedAction?.actionType;
        const foundAction = MarketplaceEventActionTypeList.find(
            (a) => a.id === actionType
        );
        setAction(foundAction || null);
    }, []);

    const isEventActionVisible = !props.isEventActionVisible
        ? true
        : props.isEventActionVisible(props.chevronDiagramEvent.id);

    const mapActionName = (): string =>
        !!chevronDiagramEvent.actionLinkText
            ? chevronDiagramEvent.actionLinkText
            : action.oppositePartyName && action.party !== props.party
            ? action.oppositePartyName
            : action.name;

    return (
        <div
            className={`column-item ${
                chevronDiagramEvent.status === TimelineEventStatus.Upcoming
                    ? 'upcoming-event'
                    : ''
            } ${
                chevronDiagramEvent.status === TimelineEventStatus.Late
                    ? 'late-event'
                    : ''
            } ${
                chevronDiagramEvent.status === TimelineEventStatus.InProgress
                    ? 'in-progress-event'
                    : ''
            }`}>
            <strong>{partyName}</strong>
            <div className="event-name">{chevronDiagramEvent.name}</div>
            <div className="start-date">
                Start Date: {chevronDiagramEvent.dayStart.toLocaleDateString()}
            </div>
            <div className="deadline">
                {chevronDiagramEvent.status ===
                TimelineEventStatus.Completed ? (
                    <>
                        Date completed:{' '}
                        {chevronDiagramEvent.dayCompleted.toLocaleDateString()}
                    </>
                ) : (
                    <>
                        Deadline:{' '}
                        {chevronDiagramEvent.dayEnd.toLocaleDateString()}
                    </>
                )}
            </div>
            {action && isEventActionVisible && (
                <div
                    className={`linked-action ${
                        chevronDiagramEvent.status ===
                        TimelineEventStatus.Completed
                            ? 'completed-linked-action'
                            : ''
                    }`}
                    onClick={() => props.onActionClick(chevronDiagramEvent)}>
                    {mapActionName()}
                </div>
            )}
        </div>
    );
};
